import {frontIndexZ, IKachelOverlay} from "./IKachelOverlay";
import {Kachel} from "../structs/Kachel";
import {calcAlign} from "../tools/calcAlign";
import {SearchMap} from "./SearchMap";
import {Search} from "../Search";

export interface IKachelInfoBox extends IKachelOverlay {
}

export let KachelInfoBox: {
    new(marker: IKachelOverlay): IKachelInfoBox;
};

export function initKachelInfoBoxClass() {
    KachelInfoBox = class extends google.maps.OverlayView {
        readonly latlng: google.maps.LatLng;
        readonly kachel: Kachel;
        readonly mapDiv: JQuery<HTMLElement>;
        readonly map: google.maps.Map;


        div: JQuery<HTMLElement> | null = null;
        width: number = 0;
        height: number = 0;

        constructor(marker: IKachelOverlay) {
            super();
            this.latlng = marker.latlng;
            this.kachel = marker.kachel;
            this.map = marker.map;
            this.mapDiv = marker.mapDiv;
            this.setMap(marker.map);
        }

        updatePos() {
            if (!this.div) return
            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            if (point) {
                this.div.css({left: point.x - this.width / 2, top: point.y - this.height + 20});
            }
        }

        draw() {
            if (!this.div) {
                this.div = this.generateDiv(div => {
                    this.width = div.outerWidth(true);
                    this.height = div.outerHeight(true);
                    this.updatePos();

                    const a = calcAlign(this.mapDiv, this.div, 60, 60, 10, 10);
                    if (a.x != 0 || a.y != 0) {
                        if (SearchMap.boundHelper.liveSearch) SearchMap.boundHelper.updateView();
                        this.map.panBy(a.x, a.y);
                    }
                });
                this.getPanes().overlayMouseTarget.appendChild(this.div[0]);
            }

            this.updatePos();
        }

        private generateDiv(resizeCall: (div: JQuery<HTMLElement>) => void): JQuery<HTMLElement> {
            const k = this.kachel;
            let r = '';
            r += '<div class="infobox" style="width: 255px">';
            r += '  <div class="content">';
            r += '    <div class="item">';
            r += '      <div class="item-image">';
            r += '        <a class="item-photo item-link" href="' + k.url + '" title="' + k.title + '" target="' + k.target + '" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">';
            r += '          <div class="item-img-container"><img data-sizes="auto" class="search lazyautosizes lazyloaded" src="' + k.photo + '" /></div>';
            r += '        </a>';
            // r += '        <div class="slideshow-controls">';
            // r += '          <div class="slideshow-back slideshow-control">';
            // r += '            <i class="icon md-48 css-icons" data-icon="" data-icon-text="chevron_left" aria-hidden="true"></i>';
            // r += '          </div>';
            // r += '          <div class="slideshow-fwd slideshow-control">';
            // r += '            <i class="icon md-48 css-icons" data-icon="" data-icon-text="chevron_right" aria-hidden="true"></i>';
            // r += '          </div>';
            // r += '        </div>';
            r += '        <a class="price-tag-wrapper" href="' + k.url + '" target="' + k.target + '">';
            r += '          <span class="price-tag">';
            r += '            <span class="price-discount" aria-hidden="true" style="display: none;">%</span>';
            r += '            <span class="price-text">' + k.price + '</span>';
            r += '          </span>';
            r += '        </a>';
            r += '      </div>';
            r += '      <a class="section-body item-section-map" href="' + k.url + '" target="' + k.target + '">';
            r += '        <h2 class="acco-title" title="' + k.title + '">';
            r += '          <span>' + k.title + '</span>';
            r += '        </h2>';
            r += '        <span class="basicinfo-wrapper" title="Personen: ' + k.persons + '">';
            r += '          <i class="icon-pers"><span class="material-icons" aria-hidden="true">person</span></i>';
            r += '          <i class="pers-count">' + k.persons + '</i>';
            r += '        </span>';
            r += '        <span class="basicinfo-wrapper" title="Schlafzimmer: ' + k.bedrooms + '">';
            r += '          <i class="icon-pers"><span class="material-icons" aria-hidden="true">hotel</span></i>';
            r += '          <i class="pers-count">' + k.bedrooms + '</i>';
            r += '        </span>';
            r += '      </a>';
            r += '    </div>';
            r += '  </div>';
            r += '</div>';
            const div = $(r);

            frontIndexZ(div, 10000);
            div.on("mouseover", () => {
                frontIndexZ(div, 10000);
                SearchMap.hoverCount++;
            });
            div.on("mouseout", () => SearchMap.hoverCount--);

            setTimeout(() => resizeCall(div), 0);
            return div;
        }

        remove() {
            if (this.div) {
                this.setMap(null);
                this.div.remove();
                this.div = null;
            }
        }
    }
}
